// extracted by mini-css-extract-plugin
export var deleteIcon = "_nq-5";
export var deleteOption = "_nq-3";
export var divider = "_nq-2";
export var downloadIcon = "_nq-4";
export var drawer = "_nq-0";
export var drawerFooter = "_nq-6";
export var drawerOpen = "_nq-1";
export var highlighted = "_nq-7";
export var lighterHighlight = "_nq-8";